import { styled } from '@mui/material/styles';

import {
  GRID_INFORMATION,
  GRID_DIVIDER,
  GRID_ACTION,
} from 'shared/components/Disclaimer/constants';
import { Paper as SharedPaper } from 'shared/components/Paper';

export const Paper = styled(SharedPaper)(({ theme }) => ({
  zIndex: theme.zIndex.modal,
  position: 'fixed',
  width: `calc(100% - 32px)`,
  right: 0,
  left: 0,
  bottom: 28,
  margin: '0 auto',
  maxHeight: 520,
  overflow: 'auto',
  display: 'grid',
  gridTemplateAreas: `
    "${GRID_INFORMATION}"
    "${GRID_DIVIDER}"
    "${GRID_ACTION}"
  `,
  gridTemplateRows: '1fr auto auto',

  [theme.breakpoints.up('md')]: {
    maxHeight: 'initial',
    width: `min(${theme.breakpoints.values.lg}px, 78%)`,
    right: 32,
    left: 'auto',
    bottom: 40,
  },
}));
